import React from "react";
import styles from "./Password.module.scss";
import {
  Controller,
  type Control,
  type FieldValues,
  type RegisterOptions,
  type UseFormRegister,
} from "react-hook-form";
import withLabelAndError from "../withLabelAndError";
import Eye from "@/components/SVGComponents/Eye";
import EyeSlash from "@/components/SVGComponents/EyeSlash";

interface PasswordProps<TFieldValues extends FieldValues = FieldValues> {
  control?: Control<TFieldValues>;
  register?: (name: string, options?: RegisterOptions) => UseFormRegister;
  validations?: RegisterOptions;
  name: string;
  placeholder?: string;
  // extra props for <input>
  [key: string]: any;
}

const Password = <TFieldValues extends FieldValues = FieldValues>({
  control,
  register,
  validations,
  name,
  placeholder,
  ...rest
}: PasswordProps<TFieldValues>) => {
  const [showPassword, setShowPassword] = React.useState(false);

  const toggleShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  const renderInput = (field: Partial<UseFormRegisterReturn> = {}) => (
    <div className={styles.inputWrapper}>
      <input
        {...field}
        {...rest}
        id={name}
        type={showPassword ? "text" : "password"}
        className={styles.inputField}
        placeholder={placeholder}
      />
      {showPassword ? (
        <EyeSlash onClick={toggleShowPassword} className={styles.eyeIcon} />
      ) : (
        <Eye onClick={toggleShowPassword} className={styles.eyeIcon} />
      )}
    </div>
  );

  if (control) {
    return (
      <Controller
        control={control}
        rules={validations}
        name={name}
        render={({ field }) => renderInput(field)}
      />
    );
  } else {
    const field = register ? register(name, validations) : {};
    return renderInput(field);
  }
};

export default withLabelAndError(Password);
export { Password };
